import { Action } from 'common/interfaces/root';
import { revenueByPageActionTypes as T } from '../actions';

const initState: RevenueByPage.Top10Store = {
  loading: false,
  error: null,
  data: null,
};

export default (state: RevenueByPage.Top10Store = initState, { type, payload }: Action): RevenueByPage.Top10Store => {
  switch (type) {
    case T.GET_TOP10_PAGES:
      return { ...state, loading: true };

    case T.GET_TOP10_PAGES_SUCCESS:
      return { ...state, loading: false, data: payload };

    case T.GET_TOP10_PAGES_ERROR:
      return { ...state, loading: false, data: payload };

    default:
      return state;
  }
};
